export let data = {
    categories: [],
    monitors: []
}

export async function fetchMonitors() {
    const res = await (await fetch('https://api.status.wolfer.fun/list')).json();
    return res;
}